export default __webpack_public_path__ + "static/media/descricao.40ac8dc6.png";